import { GUID } from "../../helpers/guid.helper";
import { NoticiaMultimedia } from "../multimedia-noticia/noticia-multimedia";

export class Noticia{
    Id: string;
    Titulo: string;
    Resumen:  string;
    Texto:  string;
    Publicado:  boolean;
    EnPortada:  boolean;
    TipoNoticiaId:  string;
    TipoNoticia:  string;
    Multimedias: NoticiaMultimedia[]= [];

    // extra
    MenuPathFull: string;

    constructor() {
        this.Id = GUID.newGuid();
        this.Publicado = false;
        this.MenuPathFull = "";
        this.TipoNoticia = "";
    }

}



// WEBPACK FOOTER //
// ./src/app/main/models/noticias/noticia.ts